module.exports = __webpack_public_path__ + "static/media/notaPrensa.452ff0ed.svg";